import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { notificationApi } from "./ApiClient";

export const notificationKeys = {
  all: ["notification"] as const,
  sms: () => [...notificationKeys.all, "sms"] as const,
};

export const smsNotificationStatusSchema = z.object({
  notificationConfig: z.object({
    patientSmsNotification: z.boolean(),
    employeeSmsNotification: z.boolean(),
  }),
});

const notificationTypeSchema = z.enum(["patient", "employee"]);
type INotificationType = z.infer<typeof notificationTypeSchema>;

export const useSmsNotificationStatus = () => {
  return useQuery({
    queryKey: notificationKeys.sms(),
    queryFn: async () => {
      const url = `center/sms`;
      return await notificationApi.get(url).json(smsNotificationStatusSchema);
    },
  });
};

export const setSmsNotificationStatus = async (
  notificationType: INotificationType,
  status: boolean,
) => {
  await notificationApi.put("center/sms", {
    json: {
      notificationType: notificationType,
      enabled: status,
    },
  });
};
